export const RSVP = 'rsvp';

export const ALREADY_REGISTERED = `${RSVP}/registered`;
